import axios, { AxiosResponse } from 'axios';
import { API_ROUTES } from '../constants';
import { HTTP_CONFIG_REPORTING, HTTP_CONFIG} from '../defineTdm';

interface SearchRequest {
  [key: string]: any;
}

interface ResponseData {
  status: number;
  ok?: boolean;
  data: any;
}

const issuesReportingService = {
  fetch: async function (searchRequest: SearchRequest): Promise<ResponseData> {
    try {
      const response: AxiosResponse = await axios.post(
        API_ROUTES.issueReporting,
        searchRequest,
        HTTP_CONFIG_REPORTING,
      );
      return { status: response.status, data: response.data };
    } catch (error: any) {
      return { status: error.response ? error.response.status : 500, data: {} };
    }
  },
};

const waiverReportingService = {
  runReport: async function (searchRequest: SearchRequest): Promise<ResponseData> {
    try {
      const response: AxiosResponse = await axios.post(
        API_ROUTES.waiverReporting,
        searchRequest,
        { timeout: 180000 },
      );
      return {
        status: response.status,
        ok: response.status >= 200 && response.status < 300,
        data: response.data,
      };
    } catch (error: any) {
      console.log(error.response ? error.response.data : {});
      return {
        status: error.response ? error.response.status : 500,
        ok: false,
        data: error.response ? error.response.data : {},
      };
    }
  },
  tripCount: async function (searchRequest: SearchRequest): Promise<ResponseData> {
    try {
      const response: AxiosResponse = await axios.post(
        API_ROUTES.waiverReportTripCount,
        searchRequest,
        { timeout: 180000 },
      );
      return {
        status: response.status,
        ok: response.status >= 200 && response.status < 300,
        data: response.data,
      };
    } catch (error: any) {
      console.log(error.response ? error.response.data : {});
      return {
        status: error.response ? error.response.status : 500,
        ok: false,
        data: error.response ? error.response.data : {},
      };
    }
  },
};

const userTripGroupsService = {
  async userTripGroups(): Promise<ResponseData> {
    try {
      const response = await fetch(API_ROUTES.userTripGroups, HTTP_CONFIG);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      return { status: response.status, data };
    } catch (error: any) {
      console.error('Error fetching user trip groups:', error);
      return { status: 500, data: [] };
    }
  },
};

export {
  issuesReportingService,
  waiverReportingService,
  userTripGroupsService,
};